import { expressFeed } from "@/mocks/leakData";

export default function ExpressFeed() {
  const [lead, ...rest] = expressFeed;
  return (
    <section id="express" className="bg-background-50">
      <div className="mx-auto max-w-7xl px-4 py-12 md:px-6 md:py-16">
        <div className="mb-8 flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
          <div>
            <span className="inline-flex items-center gap-2 text-[11px] font-bold uppercase tracking-[0.28em] text-primary-600">
              <i className="ri-flashlight-line" />
              Express
            </span>
            <h2 className="mt-2 font-heading text-3xl font-black text-foreground-950 md:text-4xl">
              抢先版速递
            </h2>
            <p className="mt-2 max-w-xl text-sm leading-relaxed text-secondary-600">
              比通稿更早一步抵达的原始爆料，标题与短摘要先行，完整证据持续放送。
            </p>
          </div>
          <a
            href="#express"
            className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-md border border-background-300 px-4 py-2 text-sm font-medium text-foreground-800 transition hover:border-primary-300 hover:text-primary-600"
          >
            全部抢先版
            <i className="ri-arrow-right-line" />
          </a>
        </div>

        {/* 头条主稿：横图大卡 */}
        <a
          href="#express"
          className="group grid overflow-hidden rounded-xl border border-background-200/80 bg-background-100 md:grid-cols-2"
        >
          <div className="relative overflow-hidden">
            <img
              src={lead.cover}
              alt={lead.title}
              className="h-64 w-full object-cover object-top transition duration-500 group-hover:scale-105 md:h-full"
            />
            <span className="absolute left-4 top-4 rounded-sm bg-primary-600 px-2 py-1 text-[11px] font-bold text-background-50">
              今日主稿
            </span>
          </div>
          <div className="flex flex-col justify-center p-6 md:p-9">
            <div className="flex flex-wrap items-center gap-2 text-xs">
              <span className="inline-flex items-center gap-1 rounded-sm bg-primary-100 px-2 py-1 font-semibold text-primary-700">
                <i className="ri-flashlight-fill text-[12px]" />
                {lead.mark}
              </span>
              <span className="text-secondary-500">{lead.tag}</span>
              <span className="ml-auto inline-flex items-center gap-1 text-accent-700">
                <i className="ri-verified-badge-fill" /> {lead.source}
              </span>
            </div>
            <h3 className="mt-4 font-heading text-xl font-black leading-snug text-foreground-950 transition group-hover:text-primary-700 md:text-3xl">
              {lead.title}
            </h3>
            <p className="mt-3 text-sm leading-relaxed text-secondary-600">{lead.summary}</p>
            <div className="mt-5 flex flex-wrap items-center gap-4 border-t border-background-200 pt-4 text-xs text-secondary-500">
              <span className="inline-flex items-center gap-1">
                <i className="ri-time-line" /> {lead.time}
              </span>
              <span className="inline-flex items-center gap-1">
                <i className="ri-eye-line" /> {lead.reads} 阅读
              </span>
              <span className="inline-flex items-center gap-1">
                <i className="ri-chat-1-line" /> {lead.comments} 讨论
              </span>
              <span className="ml-auto inline-flex items-center gap-1 font-semibold text-primary-600 transition group-hover:gap-2">
                抢先查看完整证据
                <i className="ri-arrow-right-line" />
              </span>
            </div>
          </div>
        </a>

        {/* 其余速递网格 */}
        <div className="mt-6 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {rest.map((item) => (
            <a
              key={item.id}
              href="#express"
              className="group flex flex-col overflow-hidden rounded-xl border border-background-200/80 bg-background-100 transition hover:-translate-y-0.5 hover:border-primary-200"
            >
              <div className="relative overflow-hidden">
                <img
                  src={item.cover}
                  alt={item.title}
                  className="aspect-[16/10] w-full object-cover object-top transition duration-500 group-hover:scale-105"
                />
                <span
                  className={`absolute left-3 top-3 rounded-sm px-2 py-1 text-[11px] font-bold text-background-50 ${
                    item.mark === "抢先"
                      ? "bg-accent-600"
                      : item.mark === "独家"
                        ? "bg-foreground-950"
                        : "bg-primary-600"
                  }`}
                >
                  {item.mark}
                </span>
              </div>
              <div className="flex flex-1 flex-col p-5">
                <span className="text-[11px] font-medium uppercase tracking-wider text-secondary-500">
                  {item.tag}
                </span>
                <h4 className="mt-2 line-clamp-2 font-heading text-base font-bold leading-snug text-foreground-950 transition group-hover:text-primary-700 md:text-lg">
                  {item.title}
                </h4>
                <p className="mt-2 line-clamp-2 text-[13px] leading-relaxed text-secondary-600">
                  {item.summary}
                </p>
                <div className="mt-4 flex flex-wrap items-center gap-3 border-t border-background-200/80 pt-3 text-[11px] text-secondary-500">
                  <span className="inline-flex items-center gap-1">
                    <i className="ri-time-line" /> {item.time}
                  </span>
                  <span className="inline-flex items-center gap-1">
                    <i className="ri-fire-line text-accent-600" /> {item.reads}
                  </span>
                  <span className="ml-auto inline-flex items-center gap-1 font-semibold text-primary-600">
                    详情 <i className="ri-arrow-right-line" />
                  </span>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}